import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';

import TypoEntry from 'src/components/ui/TypoEntry';
import ActionPlate from 'src/components/ui/ActionPlate';

const GroupEdit = (props) => {
	const { id, title, typos = [], onEdit, onDelete } = props;

	return (
		<Box>
			{title && <InputLabel sx={{ mb: 1 }}>{title}</InputLabel>}
			<Stack spacing={1}>
				{typos.length > 0 && (
					<>
						{typos.map((typo, index) => {
							return (
								<ActionPlate
									key={index}
									isGrey
									isPadded
									onEdit={
										typo.editable && onEdit
											? () => onEdit({ group: id, item: index })
											: undefined
									}
									onDelete={
										onDelete
											? () => onDelete({ group: id, item: index })
											: undefined
									}
								>
									<TypoEntry {...typo} />
								</ActionPlate>
							);
						})}
					</>
				)}
			</Stack>
		</Box>
	);
};

GroupEdit.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	title: PropTypes.string,
	typos: PropTypes.arrayOf(PropTypes.shape(TypoEntry.propTypes)),
	onEdit: PropTypes.func,
	onDelete: PropTypes.func,
};

export default GroupEdit;
